import React, { useState, useEffect } from 'react';
import api from '../services/bookingApi';
import './PackManagement.css'; // On réutilise le CSS existant pour cohérence

const ServiceManagement = () => {
    const [services, setServices] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        duration: 30, // par défaut 30min
        price: 0,
        category: 'coiffure'
    });
    const [editingService, setEditingService] = useState(null);
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeTab, setActiveTab] = useState('create'); // 'create' or 'list'

    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const data = await api.getServices();
            setServices(data);
        } catch (error) {
            console.error('Erreur chargement services:', error);
            setMessage('❌ Impossible de charger les services.');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'duration' || name === 'price' ? parseFloat(value) : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setIsSubmitting(true);

        try {
            if (editingService) {
                await api.updateService(editingService._id, formData);
                setMessage('✅ Service mis à jour !');
            } else {
                await api.createService(formData);
                setMessage('✅ Service créé !');
            }

            setFormData({
                name: '',
                description: '',
                duration: 30,
                price: 0,
                category: 'coiffure'
            });
            setEditingService(null);
            fetchServices();
            setActiveTab('list');

        } catch (error) {
            console.error('Erreur:', error);
            setMessage('❌ Erreur lors de l\'enregistrement.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEdit = (service) => {
        setFormData({
            name: service.name,
            description: service.description || '',
            duration: service.duration,
            price: service.price,
            category: service.category || 'coiffure'
        });
        setEditingService(service);
        setActiveTab('create');
    };

    const handleDelete = async (id) => {
        if (window.confirm('Voulez-vous vraiment supprimer ce service ?')) {
            try {
                await api.deleteService(id);
                setMessage('✅ Service supprimé !');
                fetchServices();
            } catch (error) {
                console.error('Erreur:', error);
                setMessage('❌ Erreur lors de la suppression.');
            }
        }
    };

    const cancelEdit = () => {
        setFormData({
            name: '',
            description: '',
            duration: 30,
            price: 0,
            category: 'coiffure'
        });
        setEditingService(null);
    };

    return (
        <div className="pack-management-container">
            <div className="pack-management-card">
                <h2 className="pack-management-title">
                    <span className="pack-icon">💇‍♀️</span>
                    Gestion des Services
                </h2>

                {message && (
                    <div className={`pack-message ${message.includes('❌') ? 'pack-error' : 'pack-success'}`}>
                        {message}
                    </div>
                )}

                <div className="pack-tabs">
                    <button
                        className={`pack-tab ${activeTab === 'create' ? 'active' : ''}`}
                        onClick={() => setActiveTab('create')}
                    >
                        {editingService ? 'Modifier le Service' : 'Nouveau Service'}
                    </button>
                    <button
                        className={`pack-tab ${activeTab === 'list' ? 'active' : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        Liste des Services ({services.length})
                    </button>
                </div>

                {activeTab === 'create' && (
                    <form className="pack-form" onSubmit={handleSubmit}>
                        <div className="pack-form-grid">
                            <div className="pack-form-group">
                                <label className="pack-form-label">Nom du Service *</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="pack-form-input"
                                    required
                                />
                            </div>

                            <div className="pack-form-group">
                                <label className="pack-form-label">Catégorie</label>
                                <select
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                    className="pack-form-select"
                                >
                                    <option value="coiffure">Coiffure</option>
                                    <option value="coloration">Coloration</option>
                                    <option value="soin">Soin</option>
                                    <option value="brushing">Brushing</option>
                                    <option value="autre">Autre</option>
                                </select>
                            </div>

                            <div className="pack-form-group">
                                <label className="pack-form-label">Prix (DT) *</label>
                                <input
                                    type="number"
                                    name="price"
                                    value={formData.price}
                                    onChange={handleChange}
                                    className="pack-form-input"
                                    min="0"
                                    required
                                />
                            </div>

                            <div className="pack-form-group">
                                <label className="pack-form-label">Durée (minutes) *</label>
                                <input
                                    type="number"
                                    name="duration"
                                    value={formData.duration}
                                    onChange={handleChange}
                                    className="pack-form-input"
                                    step="15"
                                    min="15"
                                    required
                                />
                                <small style={{ color: '#666' }}>Multiple de 15 min</small>
                            </div>

                            <div className="pack-form-group full-width">
                                <label className="pack-form-label">Description</label>
                                <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    className="pack-form-textarea"
                                    rows="3"
                                />
                            </div>
                        </div>

                        <div className="pack-form-actions">
                            {editingService && (
                                <button type="button" onClick={cancelEdit} className="pack-cancel-btn">
                                    Annuler
                                </button>
                            )}
                            <button type="submit" disabled={isSubmitting} className="pack-submit-btn">
                                {isSubmitting ? 'Enregistrement...' : (editingService ? 'Mettre à jour' : 'Créer')}
                            </button>
                        </div>
                    </form>
                )}

                {activeTab === 'list' && (
                    <div className="pack-list">
                        {services.length === 0 ? (
                            <div className="pack-empty">Aucun service disponible.</div>
                        ) : (
                            <div className="pack-grid">
                                {services.map(service => (
                                    <div key={service._id} className="pack-card">
                                        <div className="pack-card-header">
                                            <h3 className="pack-card-title">{service.name}</h3>
                                            <span className="pack-card-price">{service.price} DT</span>
                                        </div>
                                        <div className="pack-card-details">
                                            <div className="pack-card-detail">⏱️ {service.duration} min</div>
                                            <div className="pack-card-detail">🏷️ {service.category}</div>
                                        </div>
                                        {service.description && (
                                            <div className="pack-card-description">{service.description}</div>
                                        )}
                                        <div className="pack-card-actions">
                                            <button onClick={() => handleEdit(service)} className="pack-edit-btn">Modifier</button>
                                            <button onClick={() => handleDelete(service._id)} className="pack-delete-btn">Supprimer</button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ServiceManagement;
